import React, { useState, useEffect, useRef } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import {
    Badge,
    Box,
    Button,
    IconButton,
    LinearProgress,
    MenuItem,
    Paper,
    Tab,
    Tabs,
    TextField,
    Tooltip,
    tabsClasses,
    useTheme,
    useMediaQuery,
} from '@mui/material';

import {
    Upload,
    AllOut,
    ArrowDropDown,
    ColorLens,
    Clear,
    Close,
    CloudSync,
    Download,
    EditRoad,
    FileDownload,
    FilterAltOff,
    InsertDriveFile,
    OpenInNew,
    PictureAsPdf,
    Search,
    Storage,
    Vaccines,
    VideoFile,
    ViewWeekOutlined,
    MoreVert
} from '@mui/icons-material'


import PermissionGuard from '../../contexts/PermissionContext';

import ControlBar from '../structure/ControlBar';
import ControlDivider from '../structure/ControlDivider';
import ControlButton from '../structure/ControlButton';
import SelectExportsDialog from '../dialog/SelectExportsDialog';
import SelectEdlDialog from '../dialog/SelectEdlDialog';
import UploadExploreDialog from '../dialog/UploadExploreDialog';
import UploadExploreMobile from '../dialog/UploadExploreMobile';
import SearchDialogMobile from '../dialog/SearchDialogMobile';

import BaseMenu from '../rightclicks/BaseMenu';


export default function ExploreViewMenuBarDesktop(props) {

    const {
        requestSearch,
        clearSearch,
        clearFilter,
        searchText,
        toggleSelectedRows,
        setOpenUploadDialog,
        generateEDL,
        downloadCSV,
        downloadCDL,
        toggleEdlMenu,
        toggleExportMenu,
        toggleCdlMenu,
        selectionModel,
        setValue,
        setUploadRef,
        tabs,
        setTabs,
        value,
        filterClips
    } = props

    const fileBrowserRef = useRef(null)

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'))
    const isSm = useMediaQuery(theme.breakpoints.down('md'))
    const isMd = useMediaQuery(theme.breakpoints.down('lg'))
    const isLg = useMediaQuery(theme.breakpoints.down('xl'))

    // const [searchText, setSearchText] = useState('')
    const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null)
    const [moreCdlAnchorEl, setCdlMenuAnchorEl] = useState(null)

    const [selectEdlMenuAnchorEl, setSelectEdlMenuAnchorEl] = useState(null)
    const [openExportMenu, setOpenExportMenu] = useState(false)
    const [openEdlMenu, setOpenEdlMenu] = useState(false)
    const [uploadFileOpen, setUploadFileOpen] = useState(false)
    // const [openUploadDialog, setOpenUploadDialog] = useState(false)
    // const [uploadRef, setUploadRef] = useState(null)
    const [files, setFiles] = useState([])
    const [exportAnchorEl, setExportAnchorEl] = useState(null)
    const [edlAnchorEl, setEdlAnchorEl] = useState(null)
    const [searchVisible, setSearchVisible] = useState(false)
    const [searchAnchorEl, setSearchAnchorEl] = useState()


    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleClose = (e, tabIndex) => {
        e.stopPropagation()

        if(tabIndex === value){
            setValue(prev => prev > 0 ? prev - 1 : 0);
        }
        else if(tabIndex < value){
            setValue(prev => prev - 1);
        }
        const newTabs = tabs.filter((_, index) => index !== tabIndex);
        setTabs(newTabs)

    }


    const fileDialog = (e) => {
        setUploadRef(e.currentTarget)
        setOpenUploadDialog((prevState) => !prevState)
    }

    const searchClick = (event)=>{
        setSearchAnchorEl(event.currentTarget)
        setSearchVisible((prev) => !prev)
    }

    const handleMoreMenuClick = (event) => {
        setMoreMenuAnchorEl(event.currentTarget)
    }

    const handleCdlMenuClick = (event) => {
        setCdlMenuAnchorEl(event.currentTarget)
    }

    const handleCdlMenuClose = () => {
        setCdlMenuAnchorEl(null)
    }

    const handleSelectEdlMenuHover = (event) => {
        setSelectEdlMenuAnchorEl(event.currentTarget)
    }

    const handleMoreMenuClose = () => {
        setMoreMenuAnchorEl(null)
    }

    const handleSelectEdlMenuClose = (event) => {
        setSelectEdlMenuAnchorEl(null)
    }

    const openFileBrowser = () => {
        handleMoreMenuClose()
        fileBrowserRef.current.click()
    }

    return (
        <React.Fragment>

            <Box>
                <ControlBar>
                    <Box
                        sx={{
                            maxWidth: {
                                // xs: 100,
                                md: 200
                            } 
                        }}
                    >
                        <Tabs
                            value={value}
                            onChange={handleTabChange}
                            indicatorColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                            sx={{
                                [`& .${tabsClasses.scrollButtons}`]: {
                                    '&.Mui-disabled': { opacity: 0.2 },
                                },
                            }}>
                            {tabs.map((tab, index) => (
                                <Tab
                                    key={index}
                                    style={{
                                        textTransform: 'none',
                                        fontWeight: 'bold',
                                        color: value === index ? 'rgb(255, 255, 255)' : 'rgb(150, 150, 150)'
                                    }}
                                    label={
                                        <Box
                                            display={'flex'}
                                            height={'20px'}
                                            alignItems={'center'}
                                        >
                                            {tab}
                                            {index > 0 && (<IconButton

                                                onClick={(e) => handleClose(e, index)}
                                                sx={{
                                                    color: 'grey',
                                                    '&:hover': {
                                                        color: 'white'
                                                    }
                                                }}
                                            >
                                                <Close sx={{ 
                                                    fontSize: {xs: '20px', md: '14px'}
                                                    }}
                                                />
                                            </IconButton>)}
                                        </Box>
                                    }
                                />
                            ))}
                        </Tabs>
                    </Box>
                    <ControlDivider />
                    <Box
                        display= {"flex"}
                    >
                        {
                            isSm
                            ?
                            <React.Fragment>
                                <ControlButton
                                    title="Search"
                                    clicked={(event) => searchClick(event)}
                                >
                                    {/* Badge indicates text in search box - UI hint when search box hidden */}
                                    <Badge badgeContent={''} color='secondary' variant='dot' invisible={!searchText}>
                                        <Search fontSize="medium" style={{ fill: "white" }} />
                                    </Badge>
                                </ControlButton>
                                <SearchDialogMobile
                                    setOpen={setSearchVisible} 
                                    searchVisible={searchVisible}
                                    searchAnchorEl={searchAnchorEl} 
                                    TextField={TextField} 
                                    searchText={searchText} 
                                    requestSearch={requestSearch} 
                                    IconButton={IconButton} 
                                    clearSearch={clearSearch} 
                                />
                            </React.Fragment>
                            :
                            <TextField
                                id='explore-view-search-bar'
                                variant="standard"
                                value={searchText}
                                onChange={requestSearch}
                                placeholder="  Search…"
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault()
                                    }
                                }}
                                sx={{
                                    '& input': {
                                        color: 'white',
                                        '&::placeholder': {
                                            color: 'white'
                                        },
                                    },
                                }}
                                InputProps={{
                                    color: 'secondary',
                                    startAdornment: <Search style={{ fill: "white" }} />,
                                    endAdornment: (
                                        <IconButton
                                            title="Clear"
                                            aria-label="Clear"
                                            size="small"
                                            style={{ visibility: searchText.length > 0 ? 'visible' : 'hidden' }}
                                            onClick={clearSearch}>
                                            <Clear fontSize="small" style={{ fill: "white" }} />
                                        </IconButton>
                                    )
                                }}
                                style={{ width: 150 }} 
                            />
                        }
                        <ControlDivider />
                    </Box>


                    {
                        isSm
                        ?
                        <React.Fragment>
                            <ControlButton
                                title="More"
                                clicked={handleMoreMenuClick}
                            >
                                <MoreVert style={{ fill: "white" }} />
                            </ControlButton>
  

                            <BaseMenu
                                handleMenuClose={handleMoreMenuClose}
                                menuAnchorEl={moreMenuAnchorEl}
                            >
                                <div id='explore-view-shots-filter'>
                                <MenuItem
                                    onClick={toggleSelectedRows}>
                                    <AllOut style={{ fill: "white" }} />
                                    Toggle Selected Rows
                                </MenuItem>
                                <MenuItem
                                    onClick={clearFilter}>
                                    <FilterAltOff style={{ fill: "white" }} />
                                    Clear all filters
                                </MenuItem>
                                </div>
                                <MenuItem
                                        onClick={openFileBrowser}
                                >
                                    <Upload style={{fill: "white"}} />
                                    Upload EDL
                                </MenuItem>
                                {/* <MenuItem
                                    onClick={toggleEdlMenu}
                                >
                                    <EditRoad style={{ fill: "white" }} />
                                    Select EDL
                                </MenuItem> */}
                                <PermissionGuard permission='write:deliverables'>
                                    <MenuItem
                                        id='explore-view-generate-edl'
                                        onClick={generateEDL}
                                        disabled={selectionModel.length > 0 ? false : true}
                                    >
                                        <VideoFile style={{ fill: "white" }} />
                                        Generate EDL
                                    </MenuItem>
                                    <MenuItem
                                        id='explore-view-generate-export'
                                        onClick={toggleExportMenu}
                                        disabled={selectionModel.length > 0 ? false : true}
                                    >
                                        <InsertDriveFile style={{ fill: "white" }} />
                                        Generate an Export
                                    </MenuItem>
                                    <MenuItem
                                        id='explore-view-generate-csv'
                                        onClick={toggleCdlMenu}
                                        disabled={selectionModel.length === 0 ? true : false}
                                    >
                                        <ColorLens style={{fill: "white"}} />
                                        Generate or Inject CDL
                                    </MenuItem>
                                    <MenuItem
                                        id='explore-view-generate-csv'
                                        onClick={downloadCSV}
                                        disabled={selectionModel.length > 0 ? false : true}
                                    >
                                        <Download style={{ fill: "white" }} />
                                        Download CSV
                                    </MenuItem>
                                    <MenuItem
                                        disabled={true}
                                        onClick={downloadCDL}
                                    >
                                        <CloudSync style={{ fill: "white" }} />
                                        Push to Shotgun
                                    </MenuItem>
                                </PermissionGuard>
                                <BaseMenu
                                    handleMenuClose={handleCdlMenuClose}
                                    menuAnchorEl={moreCdlAnchorEl}
                                >
                                    <div id='explore-view-shots-filter'>
                                    <MenuItem
                                        onClick={toggleSelectedRows}>
                                        <AllOut style={{ fill: "white" }} />
                                        Livegrade
                                    </MenuItem>
                                    <MenuItem
                                        onClick={clearFilter}>
                                        <FilterAltOff style={{ fill: "white" }} />
                                        Colorfront
                                    </MenuItem>
                                    </div>
                                </BaseMenu>
                            </BaseMenu>
                            <UploadExploreMobile
                                fileBrowserRef={fileBrowserRef}
                                filterClips={filterClips}
                            />
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <div id='explore-view-edl-filter' style={{ display: 'flex' }}>
                            <Box
                                display={{
                                    xs: 'none',
                                    md: 'flex'
                                }}
                                flexDirection='column'
                            >
                                <ControlButton
                                    title="Upload EDL"
                                    clicked={fileDialog}
                                >
                                    <Upload style={{fill: "white"}} />
                                </ControlButton>
                            </Box>
                            {/* <ControlButton
                                title="Select EDL"
                                clicked={(event) => toggleEdlMenu(event)}
                            >
                                <>
                                    <EditRoad style={{ fill: "white" }} />
                                    <ArrowDropDown style={{ fill: "white" }} sx={{ fontSize: 18 }} />
                                </>
                            </ControlButton> */}
                            </div>
                            <ControlDivider />
                            <div id='explore-view-shots-filter' style={{ display: 'flex' }}>
                            <ControlButton
                                title="Clear all filters"
                                clicked={clearFilter}
                            >
                                <FilterAltOff style={{ fill: "white" }} />
                            </ControlButton>
                            <ControlButton
                                title="Toggle Selected Rows"
                                clicked={toggleSelectedRows}
                            >
                                <AllOut style={{ fill: "white" }} />
                            </ControlButton>
                            </div>

                            <ControlDivider />

                            <Box
                                display={{
                                    xs: 'none',
                                    md: 'flex'
                                }}
                                flexDirection='row'
                            >
                                <PermissionGuard permission={'write:deliverables'}>
                                <div id='explore-view-generate-export'>
                                <ControlButton
                                    title="Generate an Export"
                                    clicked={(event) => toggleExportMenu(event)}
                                >
                                    <InsertDriveFile style={{ fill: "white" }} />
                                </ControlButton>
                                </div>
                                <div id='explore-view-generate-edl'>
                                <ControlButton
                                    title="Generate EDL"
                                    clicked={generateEDL}
                                    disabled={selectionModel.length > 0 ? false : true}
                                >
                                    <VideoFile style={{ fill: "white" }} />
                                </ControlButton>
                                </div>
                                <div id='explore-view-generate-cdl'>
                                <ControlButton
                                    title="Generate or Inject CDL"
                                    clicked={toggleCdlMenu}
                                >
                                    <ColorLens style={{fill: "white"}} />
                                </ControlButton>
                                </div>
                                <ControlDivider />
                                <Tooltip
                                    title="Push to Shotgun"
                                    arrow>
                                    <Box>
                                        <ControlButton
                                            title="Push to Shotgun"
                                            disabled={true}
                                            clicked={downloadCDL}>
                                            <CloudSync style={{ fill: "white" }} />
                                        </ControlButton>
                                    </Box>
                                </Tooltip>
                                <ControlDivider />
                                <Box
                                    id='explore-view-generate-csv'
                                    display={{
                                        xs: 'none',
                                        md: 'flex'
                                    }}
                                >
                                </Box>
                                </PermissionGuard>
                            </Box>
                        </React.Fragment>
                    }
                </ControlBar>
            </Box>
        </React.Fragment>
    );
}